import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImageSlash } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';

// Capture de planning dont la dernière tentative a échoué : à la place d'un
// loader qui ne se résoudrait jamais. Le bouton « Mettre à jour » relance.
const PlanningCaptureUnavailable = () => {
  const { t } = useTranslation();
  return (
    <div
      className='--hide-from-pdf'
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        height: '100%',
        width: '100%',
        color: 'rgba(11, 34, 57, 0.55)',
        fontSize: 12,
        textAlign: 'center',
      }}
    >
      <FontAwesomeIcon icon={faImageSlash} style={{ fontSize: 22 }} />
      <span>{t('planning-capture-unavailable')}</span>
      <span style={{ fontSize: 11 }}>{t('planning-capture-unavailable-hint')}</span>
    </div>
  );
};

export default PlanningCaptureUnavailable;
